import { useEffect, useMemo, useRef, useState } from "react";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { useSearchParams } from "react-router-dom";
import moment from "moment";

import SortIcon from "../ui-icons/table/SortIcon";
import { urlDefault } from "src/constants";
import { useAppSelector } from "src/hooks/redux";
import { selectUsers } from "src/modules/users/selector";
import { EmptyList } from "../EmptyList";
import { TooltipItem } from "src/utils/Tooltip";
import { Statuses5WayNotice } from "src/pages/DashboardPage/throughcomponents/securityCard/components/statusesNotice/statusesNotice";
import { incStatus, isStrapi } from "src/api/config/systemSwitch";
import { siteUrl } from "src/api/config";

const MyTasksSecurityTable = (props: any) => {

    const { data, setExportData, customLoading, statuses, fieldsFromExel } = props;
    const [sortData, setSortData] = useState<any>([]);
    const [query, setQuery] = useSearchParams();
    const users: any = useAppSelector(selectUsers);

    const [tableHeaderContent, setTableHeaderContent] = useState<any>({
        ID: {
            title: '№',
            sort: true,
            style: { width: "4.7%" },
            sortDirection: 'default',
            sortType: 'number'
        },
        DateIncidents: {
            title: "Дата",
            sort: true,
            style: { width: "9.71%" },
            sortDirection: 'desc',
            sortType: 'date'
        },
        StatusStr: {
            title: "Статус",
            sort: true,
            style: { width: "13.7%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        SecurityRisk: {
            title: "Серьёзность",
            sort: true,
            style: { width: "11.03%" },
            sortDirection: 'default',
            sortType: 'number'
        },
        ResponsibleStr: {
            title: "ФИО инициатора",
            sort: true,
            style: { width: "12.04%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        LocationStr: {
            title: "Локация",
            sort: true,
            style: { width: "7.36%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        DepartmentStr: {
            title: "Отдел",
            sort: true,
            style: { width: "11.04%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        RegionStr: {
            title: "Участок",
            sort: true,
            style: { width: "5.35%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        ActionsStatusStr: {
            title: "Статус действий",
            sort: true,
            style: { width: "10.02%" },
            sortDirection: 'default',
            sortType: 'string'
        },
        closedDaysCount: {
            title: "Кол-во дней до окончания расследования",
            sort: true,
            style: { width: "15.05%" },
            sortDirection: 'default',
            sortType: 'number'
        }
    });

    const [tableHeaderContentExel, setTableHeaderContentExel] = useState<any>({
        ID: {
            title: '№',
            width: 50
        },
        DateIncidents: {
            title: "Дата",
            width: 50
        },
        StatusStr: {
            title: "Статус",
            width: 50
        },
        SecurityRisk: {
            title: "Серьёзность",
            width: 50
        },
        ResponsibleStr: {
            title: "ФИО инициатора",
            width: 50
        },
        LocationStr: {
            title: "Локация",
            width: 50
        },
        DepartmentStr: {
            title: "Отдел",
            width: 50
        },
        RegionStr: {
            title: "Участок",
            width: 50
        },
        Description: {
            title: "Описание",
            width: 50
        },
        TypeIncident: {
            title: "Тип несоответствия/инцидента",
            width: 50
        },
        tree: {
            title: "Корневые причины",
            width: 50
        },
        actions: {
            title: "Действия",
            width: 50
        },
        ActionsStatusStr: {
            title: "Статус действий",
            width: 50
        },
        closedDaysCount: {
            title: "Кол-во дней до окончания расследования",
            width: 50
        }
    });

    const openDocumentCard = (id: number) => {
        const newSearchParams = new URLSearchParams(query);
        newSearchParams.set("securityCard", id.toString());
        setQuery(newSearchParams);
    }

    const sortDataHandle = (sortField: string, sortDirection: string, sortType: string) => {
        const tempTableHeaderContent = { ...tableHeaderContent };
        const tempData = [...data.map((item: any) => { return { ...item, ...{ ActionsStatusStr: item.actionsIncStatus.name, ResponsibleStr: users[item.ResponsibleEmail.toLowerCase()] && users[item.ResponsibleEmail.toLowerCase()]['displayName'], RegionStr: item.Region.get_lookupValue(), DepartmentStr: item.Department.get_lookupValue(), LocationStr: item.Location.get_lookupValue(), closedDaysCount: moment(item.ClosedDate).startOf('day').diff(moment(new Date()).startOf('day'), 'days') <= 0 && 0 || moment(item.ClosedDate).startOf('day').diff(moment(new Date()).startOf('day'), 'days'), StatusStr: item.Status.get_lookupValue() } } })];
        Object.keys(tempTableHeaderContent).map((key: string) => {
            tempTableHeaderContent[key]['sortDirection'] = 'default';
        });
        if (sortDirection === 'default') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'desc';
        }
        if (sortDirection === 'desc') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'asc';
        }
        if (sortDirection === 'asc') {
            tempTableHeaderContent[sortField]['sortDirection'] = 'default';
            setSortData([...data]);
        }
        if (sortType === 'number') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                tempData.sort((a: any, b: any) => parseFloat(a[sortField]) - parseFloat(b[sortField]));
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                tempData.sort((a: any, b: any) => parseFloat(b[sortField]) - parseFloat(a[sortField]));
            }
        }
        if (sortType === 'string') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                tempData.sort((a: any, b: any) => {
                    return a[sortField].localeCompare(b[sortField]);
                });
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                tempData.sort((a: any, b: any) => {
                    return b[sortField].localeCompare(a[sortField]);
                });
            }
        }
        if (sortType === 'date') {
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'desc') {
                const distantFuture = new Date(8640000000000000);
                tempData.sort((a: any, b: any) => {
                    let dateA = a[sortField] || distantFuture;
                    let dateB = b[sortField] || distantFuture;
                    return dateA.getTime() - dateB.getTime();
                });
            }
            if (tempTableHeaderContent[sortField]['sortDirection'] === 'asc') {
                const distantFuture = new Date(8640000000000000);
                tempData.sort((a: any, b: any) => {
                    let dateA = a[sortField] || distantFuture;
                    let dateB = b[sortField] || distantFuture;
                    return dateB.getTime() - dateA.getTime();
                });
            }
        }
        setTableHeaderContent({ ...tempTableHeaderContent });
        setSortData([...tempData]);
    }

    useEffect(() => {
        if (fieldsFromExel.length > 0) {
            setSortData([...data]);
            const tempTableHeaderContent = { ...tableHeaderContent };
            Object.keys(tempTableHeaderContent).map((key: string) => {
                tempTableHeaderContent[key]['sortDirection'] = 'default';
            });
            setTableHeaderContent({ ...tempTableHeaderContent });
            if (data.length > 0) {
                const inc = data[0];
                const incQuestions = inc.Questions && JSON.parse(inc.Questions);
                if (incQuestions && Object.keys(incQuestions).length > 0) {
                    let fieldsExel: any = {};
                    Object.keys(incQuestions).forEach(key => {
                        fieldsExel[key.replace(/\d/g, '')] = {
                            title: fieldsFromExel.find((field: any) => field.key === key) && fieldsFromExel.find((field: any) => field.key === key)['title'] || key.replace(/\d/g, ''),
                            width: 50
                        }
                    });
                    let tempTableHeaderContentExel = {
                        ID: {
                            title: '№',
                            width: 50
                        },
                        DateIncidents: {
                            title: "Дата",
                            width: 50
                        },
                        StatusStr: {
                            title: "Статус",
                            width: 50
                        },
                        SecurityRisk: {
                            title: "Серьёзность",
                            width: 50
                        },
                        ResponsibleStr: {
                            title: "ФИО инициатора",
                            width: 50
                        },
                        LocationStr: {
                            title: "Локация",
                            width: 50
                        },
                        DepartmentStr: {
                            title: "Отдел",
                            width: 50
                        },
                        RegionStr: {
                            title: "Участок",
                            width: 50
                        },
                        Description: {
                            title: "Описание",
                            width: 50
                        },
                        TypeIncident: {
                            title: "Тип несоответствия/инцидента",
                            width: 50
                        },
                        tree: {
                            title: "Корневые причины",
                            width: 50
                        },
                        actions: {
                            title: "Действия",
                            width: 50
                        },
                        ActionsStatusStr: {
                            title: "Статус действий",
                            width: 50
                        },
                        closedDaysCount: {
                            title: "Кол-во дней до окончания расследования",
                            width: 50
                        },
                        ...fieldsExel
                    };
                    setTableHeaderContentExel({ ...tempTableHeaderContentExel });
                }
            }
        }

    }, [data, fieldsFromExel]);

    useEffect(() => {
        if (sortData.length > 0) {
            let exportColumns: any = [];
            Object.keys(tableHeaderContentExel).map((key: any) => {
                exportColumns = [...exportColumns, {
                    header: tableHeaderContentExel[key]['title'],
                    key: key,
                    width: tableHeaderContentExel[key]['width']
                }]
            });
            let exportData: any = [];
            sortData.forEach((item: any) => {
                let fieldsExelData: any = {};
                const incQuestionsData = item.Questions && JSON.parse(item.Questions) || {};
                if (Object.keys(incQuestionsData).length > 0) {
                    Object.keys(incQuestionsData).forEach(key => {
                        if (typeof incQuestionsData[key] === 'string' || typeof incQuestionsData[key] === 'number') {
                            fieldsExelData[key.replace(/\d/g, '')] = incQuestionsData[key]
                        } else if (Array.isArray(incQuestionsData[key])) {
                            if (!Array.isArray(fieldsExelData[key.replace(/\d/g, '')])) {
                                fieldsExelData[key.replace(/\d/g, '')] = [];
                            }
                            fieldsExelData[key.replace(/\d/g, '')] = incQuestionsData[key].join(', ');
                        } else {
                            fieldsExelData[key.replace(/\d/g, '')] = incQuestionsData[key]['name'];
                        }
                    });
                }
                exportData = [...exportData, {
                    ID: {
                        text: item.ID,
                        hyperlink: `${siteUrl}/dashboard/3/incidents-security?securityCard=${item.ID}`,
                        tooltip: item.Title
                    },
                    DateIncidents: moment(item.DateIncidents).format('DD.MM.YYYY'),
                    StatusStr: item.Status.get_lookupValue(),
                    ResponsibleStr: users[item.ResponsibleEmail.toLowerCase()] && users[item.ResponsibleEmail.toLowerCase()]['displayName'],
                    LocationStr: item.Location.get_lookupValue(),
                    DepartmentStr: item.Department.get_lookupValue(),
                    RegionStr: item.Region.get_lookupValue(),
                    Description: item.Description,
                    TypeIncident: item.TypeIncident.get_lookupValue(),
                    ActionsStatusStr: item.actionsIncStatus.name,
                    closedDaysCount: (item.Status.get_lookupId() === incStatus.finish || item.Status.get_lookupId() === incStatus.cancel || item.Status.get_lookupId() === incStatus.closed || moment(item.ClosedDate).startOf('day').diff(moment(new Date()).startOf('day'), 'days') < 0) && '-' || moment(item.ClosedDate).startOf('day').diff(moment(new Date()).startOf('day'), 'days') === 0 && 0 || moment(item.ClosedDate).startOf('day').diff(moment(new Date()).startOf('day'), 'days'),
                    tree: item.tree,
                    actions: item.actions.map((action: any) => action.Description).join(`,\u000A`) || '-',
                    ...fieldsExelData
                }]
            });
            setExportData({ columns: [...exportColumns], data: [...exportData] });
        }
    }, [sortData, users, tableHeaderContentExel]);

    return (
        <FlexCol className="w-full">
            <FlexCol className="relative">
                <FlexCol id="owd_calendar_wrapper" className="relative pb-5 overflow-x-auto bg-white rounded-lg table-custom shadow-custom scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-w-2 scrollbar-thumb-[#D1D5DB] max-h-[calc(100vh-210px)] min-h-[170px]">
                    <FlexRow className="pb-5 sticky-custom max-h-[65px] w-full bg-white pt-5 px-10 gap-5 min-w-[1950px] z-10">
                        {Object.keys(tableHeaderContent).map((fieldKey) => {
                            const key: string = fieldKey;
                            return (
                                <TableHeaderColumn
                                    key={fieldKey}
                                    sortField={fieldKey}
                                    tableHeaderContent={tableHeaderContent[key]}
                                    sortDataHandle={sortDataHandle}
                                />
                            );
                        })}
                    </FlexRow>
                    <FlexCol className="divide-y grow w-full px-10 min-w-[1950px]">
                        {sortData.map((item: any) => (
                            <FlexRow
                                className="py-4 rounded-lg -mx-2 px-2 gap-5 cursor-pointer text-[#637381] hover:bg-[#F3F4F6]"
                                key={item.ID}
                                onClick={() => openDocumentCard(item.ID)}
                            >
                                <FlexCol style={{ width: "4.7%" }} className="break-words">
                                    <TooltipItem wrapperClassName="" position="bottom-right" tooltipsReactNode={<div dangerouslySetInnerHTML={{ __html: item.Description }} />} tooltipsText="" className="w-[600px] left-0">
                                        <span className="block text-sm font-normal not-italic">{item.ID}</span>
                                    </TooltipItem>
                                </FlexCol>
                                <FlexCol style={{ width: "9.71%" }} className="break-words">
                                    <span className="block text-sm font-normal not-italic">{moment(item.DateIncidents).format('DD.MM.YYYY')}</span>
                                </FlexCol>
                                <FlexCol style={{ width: "13.7%" }} className="break-words relative">
                                    <TooltipItem wrapperClassName="" position="bottom-right" tooltipsReactNode={<Statuses5WayNotice statuses={statuses} typeInc={'Инцидент'} />} tooltipsText="" className="w-[600px] left-0">
                                        <div className="w-full flex items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                <circle cx="5" cy="5" r="5" fill={isStrapi && item.Status.get_metadata().Color || item.Status_x003a_Color.get_lookupValue()} />
                                            </svg>
                                            &nbsp;&nbsp;{item.Status.get_lookupValue()}
                                        </div>
                                    </TooltipItem>
                                </FlexCol>
                                <FlexCol style={{ width: "11.03%" }} className="break-words relative">
                                    <div className="w-full flex items-center">
                                        {item.Questions && Number(JSON.parse(item.Questions)['SecurityRisk']) <= 10 &&
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                <circle cx="5" cy="5" r="5" fill='#1A8245' />
                                            </svg>
                                        }
                                        {item.Questions && Number(JSON.parse(item.Questions)['SecurityRisk']) > 10 && Number(JSON.parse(item.Questions)['SecurityRisk']) <= 30 &&
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                <circle cx="5" cy="5" r="5" fill='#FCD34D' />
                                            </svg>
                                        }
                                        {item.Questions && Number(JSON.parse(item.Questions)['SecurityRisk']) > 30 &&
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                <circle cx="5" cy="5" r="5" fill='#F23030' />
                                            </svg>
                                        }
                                        &nbsp;&nbsp;{Number(JSON.parse(item.Questions)['SecurityRisk'])}%
                                    </div>
                                </FlexCol>
                                <FlexCol style={{ width: "12.04%" }} className="break-words">
                                    <span className="block text-sm font-normal not-italic">{users[item.ResponsibleEmail.toLowerCase()] && users[item.ResponsibleEmail.toLowerCase()]['displayName']}</span>
                                </FlexCol>
                                <FlexCol style={{ width: "7.36%" }} className="break-words">
                                    <span className="block text-sm font-normal not-italic">{item.Location.get_lookupValue()}</span>
                                </FlexCol>
                                <FlexCol style={{ width: "11.04%" }} className="break-words">
                                    <span className="block text-sm font-normal not-italic">{item.Department.get_lookupValue()}</span>
                                </FlexCol>
                                <FlexCol style={{ width: "5.35%" }} className="break-words">
                                    <span className="block text-sm font-normal not-italic">{item.Region.get_lookupValue()}</span>
                                </FlexCol>
                                <FlexCol style={{ width: "10.02%" }} className="break-words">
                                    <div className="w-full flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                            <circle cx="5" cy="5" r="5" fill={item.actionsIncStatus['color']} />
                                        </svg>
                                        &nbsp;&nbsp;{item.actionsIncStatus['name']}
                                    </div>
                                </FlexCol>
                                <FlexCol style={{ width: "15.05%" }} className="break-words">
                                    <span className="block text-sm font-normal not-italic">{(item.Status.get_lookupId() === incStatus.finish || item.Status.get_lookupId() === incStatus.cancel || item.Status.get_lookupId() === incStatus.closed || moment(item.ClosedDate).startOf('day').diff(moment(new Date()).startOf('day'), 'days') < 0) && '-' || moment(item.ClosedDate).startOf('day').diff(moment(new Date()).startOf('day'), 'days') === 0 && 0 || moment(item.ClosedDate).startOf('day').diff(moment(new Date()).startOf('day'), 'days')}</span>
                                </FlexCol>
                            </FlexRow>
                        ))}
                    </FlexCol>
                    {!customLoading && data.length === 0 &&
                        <FlexCol className="absolute pt-[60px] top-0 left-0 w-full h-full items-center justify-center min-h-[170px] max-h-[calc(100vh-210px)]">
                            <EmptyList title="Данные не найдены" />
                        </FlexCol>
                    }
                </FlexCol>
                {!customLoading && data.length > 0 && <div className="w-full my-2 py-2 text-center bg-[#012169] text-white">Список сформирован</div>}
                {customLoading && <div className="w-full my-2 py-2 text-center animate-pulse">Формируется список, пожалуйста подождите</div>}
            </FlexCol>
        </FlexCol>
    );
}

export default MyTasksSecurityTable;

export function TableHeaderColumn({ tableHeaderContent, sortDataHandle, sortField }: any) {
    return (
        <FlexCol className="select-none" style={tableHeaderContent.style}>
            <FlexRow className="gap-x-2">
                {tableHeaderContent.icon && <FlexCol>{tableHeaderContent.icon}</FlexCol>}
                <FlexCol className="font-medium whitespace-pre-line w-fit">{tableHeaderContent.title}</FlexCol>
                {tableHeaderContent.sort && (
                    <FlexCol className="w-auto cursor-pointer" onClick={() => sortDataHandle(sortField, tableHeaderContent.sortDirection, tableHeaderContent.sortType)}>
                        <SortIcon sortDirection={tableHeaderContent.sortDirection} />
                    </FlexCol>
                )}
            </FlexRow>
        </FlexCol>
    );
}
